import { CLICK_ACTIONS, CONTEXT, IMPRESSION_ACTIONS, LABELS, SCREEN_NAME } from "@payment-client/analytics/constants";
import { AnalyticsContextValue } from "@swiggy-private/checkout-core";

export const onInAppUpiHalfCard = (impressionEvent: AnalyticsContextValue["impressionEvent"]): void => {
    impressionEvent({
        category: SCREEN_NAME.PAYMENT,
        label: LABELS.ONE_TAP_UPI,
        action: IMPRESSION_ACTIONS.IMPRESSION_PAYMENT_HALF_CARD,
    });
};

export const onInAppUpiHalfCardClose = (clickEvent: AnalyticsContextValue["clickEvent"]): void => {
    clickEvent({
        category: SCREEN_NAME.PAYMENT,
        label: LABELS.ONE_TAP_UPI,
        context: CONTEXT.CLOSE,
        action: CLICK_ACTIONS.CLICK_PAYMENT_HALF_CARD,
    });
};

export const onInAppUpiHalfCardCtaClickEvent = (clickEvent: AnalyticsContextValue["clickEvent"]): void => {
    clickEvent({
        category: SCREEN_NAME.PAYMENT,
        label: LABELS.ONE_TAP_UPI,
        context: CONTEXT.GET_STARTED,
        action: CLICK_ACTIONS.CLICK_PAYMENT_HALF_CARD,
    });
};
